import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React, { useCallback, useMemo, useState } from 'react';
import { components } from 'react-select';
import classNames from 'classnames/bind';
import { arrayOf, bool, node, number, oneOfType } from 'prop-types';
import { Search } from "../../icons";
import { Portal } from "../../internal/Portal";
import { keyCode } from "../../utils/keyCodes";
import Modal from '../../Modal';
import styles from '../Select.css';
import { selectPropsPropTypes } from '../shapes';
var cx = classNames.bind(styles);
var modalMeta = {
  component: 'Select'
};
export var Menu = function Menu(_ref) {
  var _rootRef$current;

  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      search = _useState2[0],
      setSearch = _useState2[1];

  var _props$selectProps = props.selectProps,
      colorTheme = _props$selectProps.colorTheme,
      confirmLabel = _props$selectProps.confirmLabel,
      handleMenuClose = _props$selectProps.handleMenuClose,
      isDisplayedSearch = _props$selectProps.isDisplayedSearch,
      isMobile = _props$selectProps.isMobile,
      isSearchable = _props$selectProps.isSearchable,
      label = _props$selectProps.label,
      menuIsOpen = _props$selectProps.menuIsOpen,
      menuVariant = _props$selectProps.menuVariant,
      onClickOverlay = _props$selectProps.onClickOverlay,
      onInputChange = _props$selectProps.onInputChange,
      onLoadOptions = _props$selectProps.onLoadOptions,
      placeholder = _props$selectProps.placeholder,
      classes = _props$selectProps.classes,
      rootRef = _props$selectProps.rootRef,
      menuRef = _props$selectProps.menuRef,
      direction = _props$selectProps.direction,
      portalStylePosition = _props$selectProps.portalStylePosition,
      container = _props$selectProps.container,
      isMulti = props.isMulti;

  var handleChangeSearch = function handleChangeSearch(e) {
    setSearch(e.target.value);
    onInputChange(e.target.value, {
      action: 'input-change'
    });
    if (onLoadOptions) onLoadOptions();
  };

  var handleClearSearch = function handleClearSearch() {
    setSearch('');
    onInputChange('');
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (e.keyCode === keyCode.ENTER) {
      setSearch('');
      onInputChange('');
    }
  };

  var handleClickOverlay = useCallback(function () {
    if (onClickOverlay) onClickOverlay();
    handleMenuClose();
  }, [onClickOverlay, handleMenuClose]);
  var modalMultiProps = useMemo(function () {
    return {
      buttonProps: {
        size: 'large'
      },
      onConfirm: handleMenuClose,
      confirmTitle: confirmLabel
    };
  }, [handleMenuClose, confirmLabel]);
  return isMobile ? /*#__PURE__*/React.createElement(Modal, _extends({
    id: "DS_Select_Popup",
    isOpen: menuIsOpen,
    meta: modalMeta,
    mobilePosition: isSearchable ? 'full' : 'bottom',
    onOverlayClick: handleClickOverlay,
    onClose: isSearchable ? handleClickOverlay : undefined,
    theme: colorTheme,
    title: label,
    targetDisableScroll: document.body,
    withScroll: false
  }, isMulti ? modalMultiProps : {}, {
    titleProps: {
      classes: {
        root: cx('modal-content')
      }
    }
  }), isSearchable && /*#__PURE__*/React.createElement("div", {
    className: cx('Search', {
      Search_open: isDisplayedSearch || onLoadOptions
    }, classes.search)
  }, /*#__PURE__*/React.createElement("span", {
    className: cx('Search_icon', classes.searchIcon)
  }, /*#__PURE__*/React.createElement(Search, {
    block: true,
    color: "N300"
  })), /*#__PURE__*/React.createElement("input", {
    className: cx('Search_input', classes.searchInput),
    onBlur: handleClearSearch,
    onChange: handleChangeSearch,
    onKeyDown: handleKeyDown,
    placeholder: placeholder,
    value: search
  })), /*#__PURE__*/React.createElement(components.Menu, _extends({}, props, {
    className: cx('List', _defineProperty({}, "List_theme_".concat(colorTheme), colorTheme), classes.list)
  }), children)) : /*#__PURE__*/React.createElement(Portal, {
    ref: menuRef,
    interactive: true,
    anchorRef: rootRef,
    direction: direction !== null && direction !== void 0 ? direction : 'bottom',
    possibleDirections: ['bottom', 'top'],
    style: {
      width: (_rootRef$current = rootRef.current) === null || _rootRef$current === void 0 ? void 0 : _rootRef$current.clientWidth
    },
    stylePosition: portalStylePosition,
    container: container
  }, /*#__PURE__*/React.createElement(components.Menu, _extends({}, props, {
    className: cx('List', _defineProperty({
      List_variant2: menuVariant === 2
    }, "List_theme_".concat(colorTheme), colorTheme), classes.list)
  }), children));
};
Menu.propTypes = process.env.NODE_ENV !== "production" ? {
  children: oneOfType([arrayOf(node), node]).isRequired,
  // eslint-disable-next-line react/boolean-prop-naming
  isMulti: bool,
  maxMenuHeight: number,
  minMenuHeight: number,
  selectProps: selectPropsPropTypes,
  portalStylePositionL: bool,
  container: node
} : {};